import { Mutation, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';

import { Category } from '../../models/categories/category';

@Injectable({
  providedIn: 'root'
})
export class UpdateCategoriesGQL extends Mutation<UpdateCatalogResponse, UpdateCatalogInput> {
  document = gql`
  mutation updateCategories($data:UpdateCatalogInput!) {
    updateCatalog(data:$data) {
      catalogId
      categories {
        name
        categoryId
        isAffiliate
        position
      }
    }
  }
  `;
}

interface UpdateCatalogInput {
  data: {
    catalogId: string;
    name: string;
    categories: StorefrontCategoryInput[];
  };
}

interface UpdateCatalogResponse {
  updateCatalog: {
    catalogId: string;
    categories: Category[];
  };
}

export interface StorefrontCategoryInput {
  categoryId?: string;
  name: string;
  position: number;
  isAffiliate: boolean;
}
